module.exports = "/_next/static/images/chat-duotone-85ba20a8ad6c45381f107d5db095e4ff.svg";